export default {
    setBranches(state, data) {
        state.branches = data
    },
    setInActiveBranches(state, data) {
        state.inActiveBranches = data
    },
    setBranch(state, data) {
        state.branch = data
    },
    setProvince(state, data) {
        state.province = data
    },
    setCities(state, data) {
        state.cities = data
    },
    setCitiesEmpty(state) {
        state.cities = []
    },
    setUseless(state, data) {
        state.useless = data
    },
}